export const appendToPathname = (asPath: string, segment: string): string => {
    const url = new URL(asPath, "http://localhost")
    url.pathname += `/${segment}`
    return url.pathname + url.search
}
